module.exports = __webpack_public_path__ + "static/media/devilHappy.b59b8ddd.png";